import React, { Component } from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {changePageToCreateComplaintWithoutClearingCustomerData} from '../actions/Page';
import PostComplaintIssueWindowComponent from '../components/PostComplaintIssueWindow/PostComplaintIssueWindow';

class PostComplaintIssueWindow extends Component {
    
    onbtnNewComplaintWithCustomerDataClick = () => this.props.changePageToCreateComplaintWithoutClearingCustomerData();

    render(){
        return(
            <PostComplaintIssueWindowComponent
                email={this.props.email}
                onbtnNewComplaintWithCustomerDataClick={this.onbtnNewComplaintWithCustomerDataClick} />
        );
    }
}

const mapStateToProps = (state) => {
    return {
        email: state.customer.email
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        changePageToCreateComplaintWithoutClearingCustomerData: () => dispatch(changePageToCreateComplaintWithoutClearingCustomerData()),
    };
};

PostComplaintIssueWindow.propTypes = {
    email: PropTypes.string,
    changePageToCreateComplaintWithoutClearingCustomerData: PropTypes.func
};

export default connect(mapStateToProps, mapDispatchToProps)(PostComplaintIssueWindow);


// WEBPACK FOOTER //
// ./src/containers/PostComplaintIssueWindow.js